import {TranslatedKeys} from 'shared/types/translated-keys';

export interface MotorcycleProps {
  model: string;
  plate: string;
  brand: string;
  year: string;
}

export const translatedMotorcycleProps: TranslatedKeys<MotorcycleProps> = {
  model: 'Modelo',
  plate: 'Placa',
  brand: 'Marca',
  year: 'Ano',
};
